import { VStack, Text, TSizes } from '@montel/montelpro-shared-components-v2';
import { FunctionComponent } from 'react';
import { styled } from 'styled-components';

const Wrapper = styled(VStack)<{
	$minWidth?: string;
	$wordBreak: string;
}>`
	${({ $minWidth }) => $minWidth && `min-width: ${$minWidth};`}
	${({ $wordBreak }) => `word-break: ${$wordBreak};`}
`;

export const LabelAndValue: FunctionComponent<{
	label: string;
	value: React.ReactNode;
	textColor?: string;
	minWidth?: string;
	wordBreak?: string;
	labelSize?: TSizes;
	textSize?: TSizes;
}> = ({
	label,
	value,
	textColor = 'textDefault',
	minWidth,
	wordBreak = 'break-all',
	labelSize = 'xs',
	textSize = 'sm',
}) => (
	<Wrapper gap="xxs" $minWidth={minWidth} $wordBreak={wordBreak}>
		<Text size={labelSize} color={'textSubtle'}>
			{label}
		</Text>
		<Text as="span" size={textSize} color={textColor}>
			{value ?? '-'}
		</Text>
	</Wrapper>
);
